// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"2885ba34","118":"e70e14b5","191":"9f114274","234":"cdb75033","395":"64db024e","422":"7b1a982d","594":"36c9afb6","629":"65d77c56","837":"be71b163","869":"37cb70de"}[chunkId] + ".chunk.js";
};